module.exports = __webpack_public_path__ + "235605c550d39295868b413706ff6f34.svg";